import(/* webpackMode: "eager", webpackExports: ["SettingsProvider"] */ "D:\\Kalpvruks\\Kalp-Ui-New\\src\\@core\\contexts\\settingsContext.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\Kalpvruks\\Kalp-Ui-New\\src\\@layouts\\BlankLayout.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["VerticalNavProvider"] */ "D:\\Kalpvruks\\Kalp-Ui-New\\src\\@menu\\contexts\\verticalNavContext.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\Kalpvruks\\Kalp-Ui-New\\src\\components\\theme\\index.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "D:\\Kalpvruks\\Kalp-Ui-New\\src\\views\\NotFound.jsx");
